(() => {
  if (customElements.get('deferred-media')) {
    return;
  }

  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      this.poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!this.poster) return;
      this.poster.addEventListener('click', this.loadContent.bind(this));

      window.addEventListener('load', () => {
        if (window.innerWidth > 989) {
          this.loadContent();
        };
      });

      window.addEventListener('resize', () => {
        if (window.innerWidth > 989) {
          this.loadContent();
        };
      });
    }

    loadContent(focus = true) {
      window.pauseAllMedia();
      this.poster.classList.toggle('pause');

      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(
          this.querySelector(
            'template'
          ).content.firstElementChild.cloneNode(true)
        );

        this.setAttribute('loaded', true);
        const contentHolder =
          this.querySelector('[data-template-output]') || this;
        const deferredElement = contentHolder.appendChild(
          content.querySelector('video, model-viewer, iframe')
        );

        if (isIOS()) {
          deferredElement.controls = false;
        }

        deferredElement.play && deferredElement.play();

        if (focus) deferredElement.focus();
      }

      setTimeout(() => {
        this.toggleMobileVideo()
      }, 10);
    }

    toggleMobileVideo() {
      const mobileVideo = this.querySelector('.deferred-media > .media video');
      if (this.poster.classList.contains('pause')) {
        mobileVideo.play();
      };
    }

    toggleDesktopVideo() {
      window.pauseAllMedia();
      this.desktopPlayButton.classList.toggle('paused');
      this.desktopPlayButton.classList.contains('paused') ? this.desktopPlayVideo.pause() : this.desktopPlayVideo.play()
    }
  }

  customElements.define('deferred-media', DeferredMedia);
})();
